export default {
  // =================================
  "Мужской: младше 18 лет": "#1A82D5",
  "мужской: младше 18 лет": "#1A82D5",
  "Мужской: 18‑24 года": "#0D75C8",
  "мужской: 18‑24 года": "#0D75C8",
  "Мужской: 25‑34 года": "#0068BB",
  "мужской: 25‑34 года": "#0068BB",
  "Мужской: 35‑44 года": "#005BAE",
  "мужской: 35‑44 года": "#005BAE",
  "Мужской: 45-54 года": "#004FA2",
  "мужской: 45-54 года": "#004FA2",
  "Мужской: 55 лет и старше": "#004792",
  "мужской: 55 лет и старше": "#004792",
  "Мужской: Не определено": "#268EE1",
  "мужской: Не определено": "#268EE1",

  "Male: 18 years and younger": "#1A82D5",
  "male: 18 years and younger": "#1A82D5",
  "Male: 18‑24 years": "#0D75C8",
  "male: 18‑24 years": "#0D75C8",
  "Male: 25-34 years": "#0068BB",
  "male: 25-34 years": "#0068BB",
  "Male: 35‑44 years": "#005BAE",
  "male: 35‑44 years": "#005BAE",
  "Male: 45-54 years": "#004FA2",
  "male: 45-54 years": "#004FA2",
  "Male: 55 years and older": "#004792",
  "male: 55 years and older": "#004792",
  "Male: Unrecognised": "#268EE1",
  "male: Unrecognised": "#268EE1",
  // =================================
  "Женский: младше 18 лет": "#FF9DC5",
  "женский: младше 18 лет": "#FF9DC5",
  "Женский: 18‑24 года": "#FF84AC",
  "женский: 18‑24 года": "#FF84AC",
  "Женский: 25‑34 года": "#FF6A92",
  "женский: 25‑34 года": "#FF6A92",
  "Женский: 35‑44 года": "#E65179",
  "женский: 35‑44 года": "#E65179",
  "Женский: 45-54 года": "#CC375F",
  "женский: 45-54 года": "#CC375F",
  "Женский: 55 лет и старше": "#AF2E51",
  "женский: 55 лет и старше": "#AF2E51",
  "Женский: Не определено": "#FFB7DF",
  "женский: Не определено": "#FFB7DF",

  "Female: 18 years and younger": "#FF9DC5",
  "female: 18 years and younger": "#FF9DC5",
  "Female: 18‑24 years": "#FF84AC",
  "female: 18‑24 года": "#FF84AC",
  "Female: 25‑34 years": "#FF6A92",
  "female: 25‑34 years": "#FF6A92",
  "Female: 35‑44 years": "#E65179",
  "female: 35‑44 years": "#E65179",
  "Female: 45-54 years": "#CC375F",
  "female: 45-54 years": "#CC375F",
  "Female: 55 years and older": "#AF2E51",
  "female: 55 years and older": "#AF2E51",
  "Female: Unrecognised": "#FFB7DF",
  "female: Unrecognised": "#FFB7DF",
  // =================================
  "Реклама: Taboola": "#4A4A92",
  "Реклама: ExoClick": "#C374F6",
  "Реклама: ВКонтакте": "#6FCEFF",
  "Реклама: Яндекс: Директ": "#6B3E8b",
  "Реклама: Avito Контекст": "#97CF26",
  "Реклама: МаркетГид": "#6AE564",
  "Реклама: Яндекс: Не определено": "#FFDB4D",

  "Ads: Taboola": "#4A4A92",
  "Ads: ExoClick": "#C374F6",
  "Ads: VKontakte": "#6FCEFF",
  "Ads: Yandex: Direct": "#6B3E8b",
  "Ads: Avito Context": "#97CF26",
  "Ads: MarketGid": "#6AE564",
  "Ads: Yandex: Unrecognised": "#FFDB4D",
  // =================================
  "Instagram.com": "#ED4657",
  "Facebook": "#4267B2",
  "Livejournal": "#004359",
  "Twitter": "#1DA1F2",

  "В Кругу Друзей": "#BDE15D",
  "Мир тесен": "#F058A3",
  "ВКонтакте": "#507299",
  "Одноклассники": "#EE8208",
  "Прямые заходы": "#A2A2A2",
  "Не определено": "#CCCCCC",

  "V Krugu Druzey": "#BDE15D",
  "Mir Tesen": "#F058A3",
  "VKontakte": "#507299",
  "Odnoklasniki": "#EE8208",
  "Direct": "#A2A2A2",
  "Unrecognized": "#CCCCCC",
  // =================================
};